import { render, staticRenderFns } from "./LiquidacionTasa.vue?vue&type=template&id=de22088a&"
import script from "./LiquidacionTasa.vue?vue&type=script&lang=js&"
export * from "./LiquidacionTasa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports